import React from "react";
import PropTypes from "prop-types";

import Link from "shared/components/Link";
import isSpa from "shared/util/isSpa";
import Context from "shared/util/Context";

import NavBarLink from "./NavBarLink";
import LikesLink from "./LikesLink";
import UpgradeLink from "./UpgradeLink";
import MessagesButton from "./MessagesButton";
import ProfileButton from "./ProfileButton";
import BoostButton from "./BoostButton";
import DoubleTakeIcon from "./icons/DoubleTake.svg";
import SearchIcon from "./icons/Search.svg";
import DiscoverIcon from "./icons/Discover.svg";
import { selectedOptionOnNavBarEvent } from "./analytics";

import "./NavBar.scss";
import LoggedOut from "./LoggedOut";

const NavBar = ({
	isLoading,
	isLoggedIn,
	displayName,
	thumbnail,
	isStaff,
	isAlist,
	isFlagMod,
	boostTokenCount,
	messagesCount,
	likesCount,
	hasIncognitoEnabled,
	isBoosting,
	boostEndTime,
	boostStartTime,
	multiplier,
	isFinishedBoostModalOpen,
	closeFinishedBoostModal,
	startBoost,
	endBoost,
	location,
}) => {
	const { pathname } = location;
	const hasGlobalPreferences = Context.has("GLOBAL_PREFERENCES");

	return (
		<div className="navbar-container">
			<span className="navbar">
				<h1 id="logo" className="nav-logo">
					<Link
						to="/doubletake"
						onClick={() => {
							selectedOptionOnNavBarEvent("discovery");
						}}
						noSpa={!isSpa()}
					>
						<span className="icon" aria-hidden="true" />
						<span className="text">OkCupid</span>
					</Link>
				</h1>
				{!isLoading && isLoggedIn &&
					<>
						<NavBarLink
							isSelected={pathname === "/doubletake" || pathname === "/quickmatch" || pathname === "/home"}
							IconComponent={DoubleTakeIcon}
							text="DoubleTake"
							path="/doubletake"
						/>
						<NavBarLink
							isSelected={pathname === "/discovery"}
							IconComponent={DiscoverIcon}
							text="Discover"
							path="/discovery"
						/>
						{!hasGlobalPreferences &&
							<NavBarLink
								isSelected={pathname === "/match"}
								IconComponent={SearchIcon}
								text="Search"
								path="/match"
							/>
						}
						<LikesLink
							isSelected={pathname === "/who-likes-you" || pathname === "/who-you-like" || pathname === "/intros"}
							likesCount={likesCount}
						/>
						<MessagesButton
							isSelected={pathname === "/messages"}
							messagesCount={messagesCount}
						/>
					</>
				}
			</span>
			<span className="navbar">
				{!isLoading && isLoggedIn &&
					<>
						<ProfileButton
							isAlist={isAlist}
							isFlagMod={isFlagMod}
							displayName={displayName}
							thumbnail={thumbnail}
							pathname={pathname}
						/>
						{
							!isAlist && <UpgradeLink />
						}
						<BoostButton
							isStaff={isStaff}
							tokenCount={boostTokenCount}
							hasIncognitoEnabled={hasIncognitoEnabled}
							isBoosting={isBoosting}
							endTime={boostEndTime}
							startTime={boostStartTime}
							multiplier={multiplier}
							isFinishedBoostModalOpen={isFinishedBoostModalOpen}
							closeFinishedBoostModal={closeFinishedBoostModal}
							startBoost={startBoost}
							endBoost={endBoost}
						/>
					</>
				}
				{!isLoading && !isLoggedIn &&
					<LoggedOut />
				}
			</span>
		</div>
	);
};

NavBar.defaultProps = {
	isLoading: false,
	isLoggedIn: false,
	isStaff: false,
	displayName: null,
	thumbnail: null,
	isAlist: false,
	isFlagMod: false,
	boostTokenCount: 0,
	messagesCount: null,
	likesCount: null,
	hasIncognitoEnabled: false,
	isBoosting: false,
	boostEndTime: null,
	boostStartTime: null,
	multiplier: 1.1,
	isFinishedBoostModalOpen: false,
	location: window.location,
};

NavBar.propTypes = {
	isLoading: PropTypes.bool,
	isLoggedIn: PropTypes.bool,
	isStaff: PropTypes.bool,
	displayName: PropTypes.string,
	thumbnail: PropTypes.string,
	isAlist: PropTypes.bool,
	isFlagMod: PropTypes.bool,
	boostTokenCount: PropTypes.number,
	messagesCount: PropTypes.number,
	likesCount: PropTypes.number,
	hasIncognitoEnabled: PropTypes.bool,
	isBoosting: PropTypes.bool,
	boostEndTime: PropTypes.number,
	boostStartTime: PropTypes.number,
	multiplier: PropTypes.number,
	isFinishedBoostModalOpen: PropTypes.bool,
	closeFinishedBoostModal: PropTypes.func.isRequired,
	startBoost: PropTypes.func.isRequired,
	endBoost: PropTypes.func.isRequired,
	location: PropTypes.shape({
		pathname: PropTypes.string.isRequired,
	}),
};

export default NavBar;



// WEBPACK FOOTER //
// ./src/shared/components/NavBar/NavBar.jsx